import Header from "./components/Header";
import Hero from "./components/Hero";
import Products from "./components/Products";
import Services from "./components/Services";
import QuoteForm from "./components/QuoteForm";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import './index.css';


export default function App() {
  return (
    <>
      <Header />
      <Hero />
      <Products />
      <Services />
      <QuoteForm />
      <Contact />
      <Footer />
    </>
  );
}
